export default __webpack_public_path__ + "static/media/svg-6.eba83fd2.svg";